(function () {
  'use strict';

  const particleCanvas = document.getElementById('particle-canvas');
  if (particleCanvas) {
    const particleContext = particleCanvas.getContext('2d');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const particles = [];
    const pointer = { x: -1000, y: -1000 };
    let width = 0;
    let height = 0;
    let animationFrame;

    const resizeParticles = function () {
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      width = window.innerWidth;
      height = window.innerHeight;
      particleCanvas.width = width * ratio;
      particleCanvas.height = height * ratio;
      particleCanvas.style.width = width + 'px';
      particleCanvas.style.height = height + 'px';
      particleContext.setTransform(ratio, 0, 0, ratio, 0, 0);
      const count = Math.min(85, Math.max(32, Math.round((width * height) / 18000)));
      particles.length = 0;
      for (let i = 0; i < count; i++) {
        particles.push({
          x: Math.random() * width,
          y: Math.random() * height,
          vx: (Math.random() - .5) * .18,
          vy: (Math.random() - .5) * .18,
          radius: Math.random() * 1.5 + .7
        });
      }
    };
    const drawParticles = function () {
      particleContext.clearRect(0, 0, width, height);
      particles.forEach(function (particle, index) {
        if (!reducedMotion) {
          particle.x += particle.vx;
          particle.y += particle.vy;
          if (particle.x < -20 || particle.x > width + 20) particle.vx *= -1;
          if (particle.y < -20 || particle.y > height + 20) particle.vy *= -1;
          const dx = pointer.x - particle.x;
          const dy = pointer.y - particle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < 150 && distance > 0) {
            particle.x -= dx / distance * .12;
            particle.y -= dy / distance * .12;
          }
        }
        for (let nextIndex = index + 1; nextIndex < particles.length; nextIndex++) {
          const next = particles[nextIndex];
          const dx = particle.x - next.x;
          const dy = particle.y - next.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < 135) {
            particleContext.strokeStyle = 'rgba(199, 125, 255, ' + ((1 - distance / 135) * .25) + ')';
            particleContext.lineWidth = .7;
            particleContext.beginPath();
            particleContext.moveTo(particle.x, particle.y);
            particleContext.lineTo(next.x, next.y);
            particleContext.stroke();
          }
        }
        particleContext.fillStyle = 'rgba(215, 155, 255, .8)';
        particleContext.shadowColor = 'rgba(168, 85, 247, .7)';
        particleContext.shadowBlur = 7;
        particleContext.beginPath();
        particleContext.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
        particleContext.fill();
        particleContext.shadowBlur = 0;
      });
      if (!reducedMotion) animationFrame = requestAnimationFrame(drawParticles);
    };
    resizeParticles();
    drawParticles();
    window.addEventListener('resize', resizeParticles, { passive: true });
    window.addEventListener('pointermove', function (event) {
      pointer.x = event.clientX;
      pointer.y = event.clientY;
    }, { passive: true });
    window.addEventListener('pointerleave', function () {
      pointer.x = -1000;
      pointer.y = -1000;
    }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && animationFrame) cancelAnimationFrame(animationFrame);
      if (!document.hidden && !reducedMotion) drawParticles();
    });
  }

  const header = document.querySelector('.site-header');
  if (header) {
    const updateHeader = () => header.classList.toggle('site-header--scrolled', window.scrollY > 24);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  const tiltCards = document.querySelectorAll('.catalog-card');
  if (tiltCards.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    tiltCards.forEach(function (card) {
      var snakeSvg = card.querySelector('.catalog-card__snake');
      var snakes = card.querySelectorAll('.catalog-card__snake rect');
      function updateSnakeRect() {
        if (snakeSvg && snakes.length) {
          var width = Math.round(card.offsetWidth);
          var height = Math.round(card.offsetHeight);
          var radius = Math.min(12, Math.max(4, Math.round(parseFloat(getComputedStyle(card).borderTopLeftRadius) - 2)));
          var perimeter = Math.max(1, 2 * ((width - 4) + (height - 4)) - (8 - 2 * Math.PI) * radius);
          var dashLength = Math.min(340, Math.max(160, perimeter * .24));
          snakeSvg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
          snakeSvg.setAttribute('width', width);
          snakeSvg.setAttribute('height', height);
          snakes.forEach(function (snake) {
            snake.setAttribute('x', 2);
            snake.setAttribute('y', 2);
            snake.setAttribute('width', Math.max(1, width - 4));
            snake.setAttribute('height', Math.max(1, height - 4));
            snake.setAttribute('rx', radius);
            snake.setAttribute('ry', radius);
            snake.style.strokeDasharray = dashLength + ' ' + Math.max(1, perimeter - dashLength);
            snake.style.setProperty('--snake-distance', perimeter + 'px');
            snake.style.animationDuration = Math.max(1.8, perimeter / 520) + 's';
          });
        }
      }
      updateSnakeRect();
      if ('ResizeObserver' in window) {
        new ResizeObserver(updateSnakeRect).observe(card);
      } else {
        window.addEventListener('resize', updateSnakeRect, { passive: true });
      }
      card.addEventListener('pointermove', function (event) {
        if (event.pointerType === 'touch') return;
        var bounds = card.getBoundingClientRect();
        var x = (event.clientX - bounds.left) / bounds.width;
        var y = (event.clientY - bounds.top) / bounds.height;
        card.style.setProperty('--card-rotate-x', ((.5 - y) * 20).toFixed(2) + 'deg');
        card.style.setProperty('--card-rotate-y', ((x - .5) * 24).toFixed(2) + 'deg');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--card-rotate-x', '0deg');
        card.style.setProperty('--card-rotate-y', '0deg');
      });
    });
  }

  const qtyButtons = document.querySelectorAll('.cart-item__qty-btn');
  qtyButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const line = this.getAttribute('data-line');
      const action = this.getAttribute('data-action');
      const input = document.querySelector('.cart-item__qty-input[data-line="' + line + '"]');
      if (!input) return;
      let qty = parseInt(input.value, 10) || 0;
      if (action === 'increase') qty++;
      if (action === 'decrease') qty = Math.max(0, qty - 1);
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  const qtyInputs = document.querySelectorAll('.cart-item__qty-input');
  qtyInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      this.form.submit();
    });
  });

  document.querySelectorAll('[data-paypal-checkout]').forEach(function (button) {
    button.addEventListener('click', function () {
      const apiUrl = this.getAttribute('data-payment-api-url');
      const amount = this.getAttribute('data-payment-amount');
      if (!apiUrl || !amount) return;
      this.disabled = true;
      this.textContent = 'Connecting to PayPal…';
      fetch(apiUrl.replace(/\/$/, '') + '/api/paypal/orders', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ amount: amount })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.error || 'Unable to start PayPal checkout');
            return data;
          });
        })
        .then(function (data) { window.location.href = data.approvalUrl; })
        .catch(function (error) {
          button.disabled = false;
          button.textContent = 'Pay with PayPal';
          window.alert(error.message);
        });
    });
  });

  const quickview = document.getElementById('quickview');
  const quickviewBody = document.getElementById('quickview-body');
  if (quickview && quickviewBody) {
    const CACHE_KEY = 'anz_product_cache';
    const CACHE_TTL = 30 * 60 * 1000;
    const STALE_TTL = 24 * 60 * 60 * 1000;
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const embeddedData = (function () {
      const el = document.getElementById('quickview-data');
      if (!el) return {};
      try {
        const parsed = JSON.parse(el.textContent);
        const map = {};
        if (parsed && parsed.products) parsed.products.forEach(function (p) { map[p.handle] = p; });
        return map;
      } catch (e) { return {}; }
    })();

    const readCache = function () {
      try { return JSON.parse(localStorage.getItem(CACHE_KEY)) || {}; }
      catch (e) { return {}; }
    };
    const writeCache = function (data) {
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch (e) {}
    };
    const getCached = function (handle) {
      if (embeddedData[handle]) return { p: embeddedData[handle], t: Date.now() };
      const cache = readCache();
      const entry = cache[handle];
      if (!entry) return null;
      const age = Date.now() - entry.t;
      if (age > STALE_TTL) return null;
      return entry;
    };
    const setCached = function (handle, product) {
      const cache = readCache();
      cache[handle] = { p: product, t: Date.now() };
      writeCache(cache);
    };
    const evictCached = function (handle) {
      const cache = readCache();
      delete cache[handle];
      writeCache(cache);
    };

    const fetchProduct = function (handle) {
      if (embeddedData[handle]) return Promise.resolve(embeddedData[handle]);
      const endpoint = rootUrl + 'products/' + handle + '.js';
      return fetch(endpoint, { headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('Not found');
          return r.json();
        })
        .then(function (p) { setCached(handle, p); return p; })
        .catch(function () { evictCached(handle); return null; });
    };

    const prefetchAll = function () {
      const handles = [];
      document.querySelectorAll('[data-quickview]').forEach(function (btn) {
        const h = btn.getAttribute('data-handle');
        if (h && handles.indexOf(h) === -1) handles.push(h);
      });
      handles.forEach(function (handle) {
        if (embeddedData[handle]) return;
        const cached = getCached(handle);
        if (cached && (Date.now() - cached.t) < CACHE_TTL) return;
        fetchProduct(handle);
      });
    };
    const schedulePrefetch = window.requestIdleCallback || function (cb) { setTimeout(cb, 1200); };
    schedulePrefetch(prefetchAll);

    const formatMoney = function (cents) {
      const amount = (cents / 100).toFixed(2);
      const fmt = (window.Shopify && window.Shopify.moneyFormat) || '${{amount}}';
      return fmt.replace('{{amount}}', amount).replace('{{amount_with_comma_separator}}', amount);
    };
    const stripHtml = function (html) {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return (tmp.textContent || tmp.innerText || '').trim();
    };
    const renderProduct = function (p, fallbackTitle, url) {
      const imgHtml = p.featured_image
        ? '<img class="quickview__media-img" src="' + p.featured_image + '" alt="' + (p.title || '') + '">'
        : '<div class="quickview__media-placeholder">?</div>';
      const titleText = p.title || fallbackTitle;
      let priceHtml = '<strong>' + formatMoney(p.price) + '</strong>';
      if (p.compare_at_price && p.compare_at_price > p.price) {
        priceHtml += '<del>' + formatMoney(p.compare_at_price) + '</del>';
      }
      const descText = p.description ? stripHtml(p.description) : '';
      quickviewBody.innerHTML =
        '<div class="quickview__content">' +
          '<div class="quickview__media">' + imgHtml + '</div>' +
          '<div class="quickview__details">' +
            '<p class="eyebrow">Quick view</p>' +
            '<h2>' + titleText + '</h2>' +
            '<div class="quickview__price">' + priceHtml + '</div>' +
            (descText ? '<p class="quickview__desc">' + descText.substring(0, 220) + (descText.length > 220 ? '…' : '') + '</p>' : '') +
            '<a class="quickview__cta" href="' + url + '">View full product <b>↗</b></a>' +
          '</div>' +
        '</div>';
    };
    const openQuickview = function (handle, fallbackTitle, url) {
      quickview.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const cached = getCached(handle);
      if (cached) {
        renderProduct(cached.p, fallbackTitle, url);
        if (Date.now() - cached.t > CACHE_TTL) {
          fetchProduct(handle).then(function (p) { if (p && quickview.getAttribute('aria-hidden') === 'false') renderProduct(p, fallbackTitle, url); });
        }
        return;
      }
      quickviewBody.innerHTML = '<div class="quickview__loading">Loading…</div>';
      fetchProduct(handle).then(function (p) {
        if (p) renderProduct(p, fallbackTitle, url);
        else quickviewBody.innerHTML = '<div class="quickview__details"><p class="quickview__desc">Could not load product. <a href="' + url + '">Open product page ↗</a></p></div>';
      });
    };
    const closeQuickview = function () {
      quickview.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      quickviewBody.innerHTML = '<div class="quickview__loading">Loading…</div>';
    };

    document.querySelectorAll('[data-quickview]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const handle = this.getAttribute('data-handle');
        const url = this.getAttribute('data-url');
        const title = this.getAttribute('data-title') || 'Product';
        if (handle) openQuickview(handle, title, url);
      });
    });
    quickview.querySelectorAll('[data-quickview-close]').forEach(function (el) {
      el.addEventListener('click', closeQuickview);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && quickview.getAttribute('aria-hidden') === 'false') closeQuickview();
    });
  }
})();
